module.exports = __webpack_public_path__ + "img/back_line.232c34a7.png";